import { NAME } from './constants'
import R from 'ramda'

import { fromNullable } from 'data.maybe'
// eslint-disable-next-line no-unused-vars
import { getApiTargetInfo } from 'core'
const getState = state => state[NAME]
const getCoreState = state => state.core

export const getUnitMap = R.compose(state => state.unitNameMap, getCoreState)
export const getUnitIds = R.compose(
  state => state.units.map(u => u.unitId),
  getCoreState
)
export const getUnitFilter = R.compose(state => state.fuzzyFilter, getState)
// export const getScreenSize = R.compose(state => state.screenSize, getState)
export const getScreenSize = _ => ({ height: 700, width: 1050 })

export const getEntityTargetInfo = R.compose(
  state => state.apiTargetInfo,
  getCoreState
)

// export const getEntityTargetInfo = getApiTargetInfo

// export const getUnitGroupFilter = R.compose(state => state.unitGroups.selected, getState)
// export const getUnitGroupList = R.compose(state => state.unitGroups.groupList, getState)
// export const getUnitGroupMap = R.compose(state => state.unitGroups.groupToUnitMap, getState)
export const getUnitGroupFilter = R.compose(
  state => state.unitGroups.selected,
  getState
)
export const getUnitGroupList = R.compose(
  // state => state.unitGroups.groupList,
  state => [
    { text: 'All Unit Groups', value: 'ALL' },
    ...state.unitGroups.map(g => ({ text: g.unitGroup, value: g.unitGroup })),
  ],
  getCoreState
)
export const getUnitGroupMap = R.compose(
  // state => state.unitGroups.groupToUnitMap,
  state =>
    state.unitGroups
      .map(g => ({ [g.unitGroup]: g.units }))
      .reduce((a, b) => ({ ...a, ...b }), {}),
  getCoreState
)
export const getUnitGroup = R.compose(state => state.unitGroups, getState)

export const getFilterAdjusting = R.compose(
  state => state.filterAdjusting,
  getState
)

const unitGroupPrediate = (groupToUnitMap, unitGroup) => id =>
  unitGroup === 'ALL' ||
  fromNullable(groupToUnitMap[unitGroup])
    .map(ids => R.contains(id, ids))
    .getOrElse(false)

const unitFuzzyPredicate = (unitMap, unitFilter) => id =>
  fromNullable(unitFilter)
    .map(filter =>
      fromNullable(unitMap[id])
        .map(name => name.toLowerCase().indexOf(filter.toLowerCase()) >= 0)
        .getOrElse(false)
    )
    .getOrElse(true)

export const getFilteredUnitList = state => {
  const unitGroupP = unitGroupPrediate(
    getUnitGroupMap(state),
    getUnitGroupFilter(state)
  )
  const groups = Object.keys(getGroups(state))
  const filter = getUnitFilter(state)
  const fuzzyP = unitFuzzyPredicate(getUnitMap(state), getUnitFilter(state))
  const filteredGroups = groups.filter(
    g =>
      R.isNil(filter) ||
      filter.trim().length === 0 ||
      g.toLowerCase().contains(filter.toLowerCase())
  )

  return [
    ...getUnitIds(state).filter(id => unitGroupP(id) && fuzzyP(id)),
    ...filteredGroups,
  ]
}

export const getYear = R.compose(state => state.year, getState)

export const getAllUnits = R.compose(state => state.allUnits, getState)

export const getAllGroups = R.compose(state => state.allGroups, getState)

export const getGroups = R.compose(
  R.reduce((a, b) => ({ ...a, ...b }), {}),
  R.map(g => ({ [g.unitGroup]: g.units })),
  state => state.unitGroups,
  getCoreState
)

export const getSelectedUnits = R.compose(
  state => state.selectedUnits,
  getState
)

export const getSelectedGroups = R.compose(
  state => state.selectedGroups,
  getState
)
